/** Strip thumbnail height in px (overlaid at the bottom of the main media). */
export const COMPOSITION_CARD_EDIT_STRIP_HEIGHT_PX = 50;

/**
 * Max strip items before collapsing the rest into "+N". Heuristic for typical
 * card widths when edit aspect ratios are unknown until images load.
 */
export const COMPOSITION_CARD_EDIT_STRIP_MAX_VISIBLE = 6;
